"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.update = exports.onWheel = exports.get = void 0;
var imports_1 = require("@lib/imports");
var mathUtils_sidecar_1 = require("@lib/mathUtils-sidecar");
var common_sidecar_1 = require("@main/common-sidecar");
var voyageCamera_sidecar_1 = require("@voyage/camera/voyageCamera-sidecar");
var voyageGameManager_sidecar_1 = require("@voyage/game-status/voyageGameManager-sidecar");
var _obj = null;
function get() {
    if (!_obj) {
        _obj = create();
    }
    return _obj;
}
exports.get = get;
var _zooms = [0.25, 0.5, 0.75, 1, 1.5, 2, 3, 4];
var _zoomIdx = imports_1.l.findIndex(_zooms, function (c) { return c === 1; });
function create() {
    var obj = {};
    var s = common_sidecar_1.common.getPhaserScene();
    s.input.on('wheel', function (_pointer, _gameObjects, _deltaX, deltaY, _deltaZ) {
        if (voyageGameManager_sidecar_1.voyageGameManager.get().mode === 'game') {
            onWheel(deltaY);
        }
    });
    return obj;
}
function onWheel(deltaY) {
    // console.log(
    //   'camera zoomer mouse wheel',
    //   deltaY,
    //   '' + voyageGameManager.get().mode,
    //)
    if (deltaY > 0) {
        _zoomIdx--;
    }
    if (deltaY < 0) {
        _zoomIdx++;
    }
    _zoomIdx = mathUtils_sidecar_1.mathUtils.clamp(_zoomIdx, 0, _zooms.length - 1);
    voyageCamera_sidecar_1.voyageCamera.setZoom(_zooms[_zoomIdx]);
}
exports.onWheel = onWheel;
function update() {
    var obj = get();
}
exports.update = update;
